module.exports = __webpack_public_path__ + "media/images/training--76fd1465.png";